import { render, staticRenderFns } from "./EventPostCard.vue?vue&type=template&id=b3a527d4&scoped=true&lang=pug&"
import script from "./EventPostCard.vue?vue&type=script&lang=js&"
export * from "./EventPostCard.vue?vue&type=script&lang=js&"
import style0 from "./EventPostCard.vue?vue&type=style&index=0&id=b3a527d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a527d4",
  null
  
)

export default component.exports